import React from 'react';
import {Body, Checkbox} from '@lightricks/react-design-system';
import styles from './RequiredApprovalSteps.module.scss';

type StepCheckboxProps = {
  step: string;
  label: string;
  checked: boolean;
  disabled: boolean;
  onAdd: (step: string) => void;
  onRemove: (step: string) => void;
};

function StepCheckbox({
  step,
  label,
  checked,
  disabled,
  onAdd,
  onRemove,
}: StepCheckboxProps) {
  const onChange = (value: boolean) => {
    if (value) {
      onAdd(step);
    } else {
      onRemove(step);
    }
  };

  return (
    <div className={styles.checkboxRow}>
      <Checkbox
        value={checked}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      />
      <Body size="md">{label}</Body>
    </div>
  );
}

export default StepCheckbox;
